// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"calculation-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 2H22V22H2V2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 2H22V22H2V2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6 8H8M8 8H10M8 8V6M8 8V10M14 8H18M14 14.5H18M14 17.5H18M6.58575 14.5859L7.99981 16M7.99981 16L9.41418 17.4144M7.99981 16L9.41388 14.5859M7.99981 16L6.58545 17.4144","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-calculation-1')
export default class Calculation1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calculation-1',
    }
  }
}
